import { bind, classNames, Component, effect, h, signal, tag } from "omi";

import { onEscPress } from "@/utils/keys";
import { Store } from "@/store";
import { tailwind } from "@/tailwind";

@tag("nav-container")
export class NavContainer extends Component {
  static css = [tailwind];

  private hoverTimeoutId: number | undefined;
  private wasOpenedViaHover = signal(false);

  installed() {
    let removeListener: () => void;

    effect(() => {
      if (Store.app.isNavOpen.value) {
        removeListener = onEscPress(this.handleClose);
      } else {
        this.wasOpenedViaHover.value = false;
        removeListener && removeListener();
      }
    });
  }

  @bind
  private handleClose() {
    Store.app.toggleNav(false, "close-btn");
  }

  @bind
  private handleHoverTriggerMouseEnter() {
    this.hoverTimeoutId = window.setTimeout(() => {
      this.wasOpenedViaHover.value = true;
      Store.app.toggleNav(true, "hover");
    }, 150);
  }

  @bind
  private handleHoverTriggerMouseLeave() {
    if (this.hoverTimeoutId != null) {
      clearTimeout(this.hoverTimeoutId);
      this.hoverTimeoutId = undefined;
    }
  }

  @bind
  private handleBackgroundClick(e: MouseEvent) {
    e.preventDefault();
    e.stopPropagation();

    this.handleClose();
  }

  render() {
    const isVisible = Store.app.isNavOpen.value;

    return (
      <>
        <div
          id="background"
          style={"--animate-duration: 0.3s"}
          class={classNames(
            "backdrop-blur-xs bg-[#0000001A] transition-all fixed left-0 right-0 top-0 z-30 bottom-0 animate__animated animate-fadeInFast",
            { hidden: !isVisible },
          )}
          onClick={e => this.handleBackgroundClick(e)}
        ></div>

        <div
          id="hover-trigger"
          onMouseEnter={this.handleHoverTriggerMouseEnter}
          onMouseLeave={this.handleHoverTriggerMouseLeave}
          class={classNames("fixed transition-none left-0 top-0 bottom-0 group hidden sm:block sm:w-5 lg:w-8 xl:w-14", {
            hidden: isVisible,
          })}
        ></div>

        <div
          class={classNames(
            "ease-in-out overflow-y-hidden duration-300 group-hover:translate-x-0 overscroll-y-none fixed transition-all z-30 left-0 bottom-24 xl:bottom-0 top-0 max-w-md w-full",
            {
              "translate-x-0 ": isVisible,
              "-translate-x-full": !isVisible,
            },
          )}
          onMouseLeave={
            this.wasOpenedViaHover.value
              ? e => {
                  if (e.clientX > 48) {
                    Store.app.toggleNav(false, "hover");
                  }
                }
              : undefined
          }
        >
          <div class="h-full p-6">
            <slot></slot>
          </div>
        </div>
      </>
    );
  }
}
